import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
// import {Helmet} from "react-helmet";
// import registerServiceWorker from './registerServiceWorker';
import {getI18nextConfig} from './app/common/config/i18nConfiguration';
import {I18nextProvider} from 'react-i18next';

ReactDOM.render(
    <I18nextProvider i18n={getI18nextConfig()}>
        <App/>
    </I18nextProvider>,
    document.getElementById('root')
);
// if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
//     Helmet.renderStatic();
// }
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js